// extracted by mini-css-extract-plugin
export default {"variable-list":"styles_variable-list__TLnMs"};